import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as serviceWorker from 'serviceWorker';
import { useTranslation } from 'react-i18next';
import { LocalStorage } from 'common/bridges/local-storage.bridge';
import { ignoreListForPwaInstallation } from 'common/constants/routing.constants';
import {
  onServiceWorkerUpdate,
  withServiceWorkerUpdater,
} from './vendor/pwa-updater';

import { ChromeAndroid } from './components/ChromeAndroid';
import { SafariIOS } from './components/SafariIOS';
import { detectBrowserFN } from './utils';

const PWAGenerator = ({
  newServiceWorkerDetected,
  onLoadNewServiceWorkerAccept,
}) => {
  const { t } = useTranslation();

  /* Type of browser and OC for start pwa installetion procces */
  const [pwaType, setPwaType] = useState('');

  /* deferredPrompt event */
  const [deferredPrompt, setDeferredPrompt] = useState({});

  /**
   * register serviceWorker.
   */
  useEffect(() => {
    serviceWorker.register({
      onUpdate: onServiceWorkerUpdate,
    });
  }, []);

  /**
   * get DeferredPrompt when manifest json ready (only for chrome in android).
   * @param {object} e.
   */
  const beforeInstallListener = (e) => {
    const type = detectBrowserFN();
    setPwaType(type);

    e.preventDefault();
    // Stash the event so it can be triggered later.
    setDeferredPrompt(e);
  };

  useLayoutEffect(() => {
    const pwaCanceledOrUsed = LocalStorage.get('pwaCanceledOrUsed');
    const isInvalidRoute = ignoreListForPwaInstallation.includes(
      window.location.pathname,
    );
    if (!pwaCanceledOrUsed && !isInvalidRoute) {
      const type = detectBrowserFN();
      if (type === 'isSafariIos') {
        setPwaType(type);
      }
      window.addEventListener('beforeinstallprompt', beforeInstallListener);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallListener);
    };
  }, [window.location.pathname]);

  /* install to android handler */
  const installToAndroid = async () => {
    deferredPrompt.prompt(); // Wait for the user to respond to the prompt
    const choiceResult = await deferredPrompt.userChoice;

    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the PWA prompt');
    } else {
      console.log('User dismissed the PWA prompt');
    }
    setDeferredPrompt(null);
    setPwaType('');
    LocalStorage.set('pwaCanceledOrUsed', true);
  };

  /**
   * Close PWA installer.
   */
  const handleClosePWA = () => {
    LocalStorage.set('pwaCanceledOrUsed', true);
    setPwaType('');
  };

  useEffect(() => {
    if (newServiceWorkerDetected) onLoadNewServiceWorkerAccept();
  }, [newServiceWorkerDetected]);

  return null;
  return (
    <>
      {
        {
          isSafariIos: <SafariIOS handleClose={handleClosePWA} t={t} />,
          isChromeAndroid: (
            <ChromeAndroid
              installToAndroid={installToAndroid}
              handleClose={handleClosePWA}
              t={t}
            />
          ),
        }[pwaType]
      }
    </>
  );
};

export default withServiceWorkerUpdater(PWAGenerator);
